import API from 'services/API';

export default function deleteInspection(data) {
  let requestData = new FormData();
  requestData.append('taxId', data.id);

  return API.request({
    method: 'POST',
    url: '/deleteTaxAuthority',
    data: requestData,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}
